export default __webpack_public_path__ + "static/media/ThankyouDevice2.8617ade9.png";